export const MACHINERY_REQUEST_TAGS = {
    MACHINERY_UPDATE_REQUESTS: "MachineryUpdateRequests",
} as const;